import { useCallback, useContext } from 'react';

import DeviceType from '../../types/Device';

import { DeviceTypeProviderContext } from './index';

const useDeviceType = () => {
	const { state } = useContext(DeviceTypeProviderContext);

	return state;
};

export const useUpdateDeviceType = () => {
	const { state, dispatch } = useContext(DeviceTypeProviderContext);

	const setDeviceType = useCallback(
		(deviceType: DeviceType) => {
			dispatch({ type: 'set-device-type', deviceType });
		},
		[dispatch]
	);

	const updateDeviceType = useCallback(
		(deviceType: Partial<DeviceType>) => {
			dispatch({ type: 'update-device-type', deviceType });
		},
		[dispatch]
	);

	return {
		deviceType: state,
		setDeviceType,
		updateDeviceType,
	};
};

export default useDeviceType;
